import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['carModel'])
  },
  methods: {
    postIframeEvent(eventName) {
      const a = document.createElement('a');
      let link = null;
      switch (eventName) {
        case 'testDrive':
          link = 'https://www.volkswagen.ru/app/dccforms/vw-ru/test-drive/ru/dealerselector/30900/+/+/+/+/+/carline/+/+/+/+/'
          break;
        case 'configurator':
          link = this.carModel === 'jetta' ? 'https://www.volkswagen.ru/ru/models/jetta.html#CONFIGURE' :
            'https://www.volkswagen.ru/ru/models/polo-new.html#CONFIGURE'
          break;
        case 'requestOffer':
          link = this.carModel === 'jetta' ? 'https://www.volkswagen.ru/app/dccforms/vw-ru/zapros-predlozheniya/ru/modelselector/30900/+/+/+/+/+/carline/+/+/+/+/' :
            'https://www.volkswagen.ru/app/dccforms/vw-ru/zapros-predlozheniya/ru/dealerselector/30202/+/+/+/+/+/carline/+/+/+/+/'
          break;
        case 'carsInStock':
          link = this.carModel === 'jetta' ? 'https://cars.volkswagen.ru/jetta' : 'https://cars.volkswagen.ru/polo-new/'
          break;
      }

      if (link) {
        setTimeout(() => {
          a.href = link
          a.target = '_blank'
          a.click()
        }, 1);
      }

      try {
        const parent = window.parent
        console.log({
          "type" : "iframe",
          "event": "custom.postMessage",
          "eventAction": "showroom." + eventName,
          "eventCategory": 'showroom_' + this.carModel
        })
        if (typeof parent != "undefined" && parent != window) {
          if (typeof parent.postMessage != "undefined") {
            let message = {
              "type" : "iframe",
              "event": "custom.postMessage",
              "eventAction": "showroom." + eventName,
              "eventCategory": 'showroom_' + this.carModel
            }

            const messageJSON = JSON.stringify(message);
            parent.postMessage(messageJSON, "*");
          }
        } else {
          console.log('postMessage method allowed only inside iframe')
        }
      } catch(err){
        console.log(err)
      }
    }
  }
}